<template>
  <section class="quote">
    <div class="container">
      <p class="quote-line">
        <span class="quote-text">Gus Machado {{ new Date().getFullYear() }}</span>
      </p>
    </div>
  </section>
</template>

<style scoped>
section.quote {
  min-height: 0;
  background: var(--color-bg-dark);
  color: var(--color-light);
  /* Removido o flex do section para não interferir no container */
}

.container {
  max-width: 1100px;
  width: 100%;       /* Igual ao componente de contato */
  margin: 0 auto;    /* Centraliza o bloco na tela */
  padding: 40px 24px; /* Igual ao componente de contato */
  text-align: left;  /* Garante o alinhamento do texto à esquerda */
}

.quote-line {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 0;
  align-items: baseline;
  justify-content: flex-start; /* Garante que os itens flex fiquem na esquerda */
}

.quote-text {
  min-width: 0;
  font-size: 16px; /* Tamanho reduzido (igual ao seu .copied-text) */
  opacity: 0.8;    /* Deixa um pouco mais discreto, se desejar */
}

@media (aspect-ratio <= 3/4) {
  .container {
    max-width: none;
    width: 100%;
    /* Ajustado para 16px para bater com o seu @media de contato */
    padding-left: 16px; 
    padding-right: 16px;
  }

  .quote-line {
    width: 100%;
  }
}
</style>